import React from 'react';
import { Grid } from '../../../../../components/Grid';
import { GridCell } from '../../../../../components/GridCell';

interface ProductDatasheetProps {
  category: string;
  productType: string;
  productState: string;
  warranty: string;
}

export const ProductDatasheet = ({
  category,
  productType,
  productState,
  warranty,
}: ProductDatasheetProps) => {
  const dataSheetLabel = 'f14 fw2 boulder ma0';
  const dataSheetValue = 'f14 fw4 abbey ttc';

  return (
    <Grid className="flex-column-ns">
      <GridCell width={[1 / 2, 1]} className="flex flex-column flex-row-ns justify-between-ns">
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Categoria</p>
          <b className={dataSheetValue}>{category}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Tipo</p>
          <b className={dataSheetValue}>{productType}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Estado da peça</p>
          <b className={dataSheetValue}>{productState}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24">
          <p className={dataSheetLabel}>Garantia</p>
          <b className={dataSheetValue}>{warranty}</b>
        </GridCell>
      </GridCell>
    </Grid>
  );
};
